import Topic from './community/topic/topic'
import TopicDetail from './community/topic/topicDetail/topicDetail'
import TopicLook from './community/topic/look'
import InvitationManager from './community/invitation/invitationManager'
import InvitationDetail from './community/invitation/invitationDetail/invitationDetail'
import InvitationLook from './community/invitation/invitationInfo/invitationLook'
import ActivityManager from './activity/activityManager'
import ActivityDetail from './activity/activityDetail/activityDetail'
import ActivityLook from './activity/activityDetailInfo/activityLook'
import ActivityTopic from './activity/activityTopic'
import ActivityPartManager from  './activity/activityPart/activityPartManager'
import ActivityPartDetail from './activity/activityPart/activityPartDetail/activityPartDetail'
import ActivityPartLook from './activity/activityPart/activityPartInfo/activityPartLook'
import ActivityMessageManager from './activity/activityMessage/activityMessageManager'
import ActivityMessageDetail from './activity/activityMessage/activityMessageDetail/activityMessageDetail'
import TopicFollow from './community/follow'
import ShortVideoManager from './shortVideo/index'
import ShortVideoLook from './shortVideo/shortVideoLook'
import ShortVideoDetail from './shortVideo/shortVideoDetail/shortVideoDetail'
import ShortVideoRecord from './shortVideo/shortVideoRecord/shortVideoRecord'
import ShortVideoScreenManager from './shortVideo/screen/index'
import ShortVideoScreenRecordManager from './shortVideo/screen/record/index'
import ShortVideoScreenToDeal from './shortVideo/screen/toDeal/index'
import ShortVideoPersonRelationManager from './shortVideo/personRelation/index'
import ShortVideoMessageManager from './shortVideo/message/index'

export {
  Topic,
  TopicDetail,
  TopicLook,
  InvitationManager,
  InvitationDetail,
  InvitationLook,
  ActivityManager,
  ActivityDetail,
  ActivityLook,
  ActivityTopic,
  ActivityPartManager,
  ActivityPartDetail,
  ActivityPartLook,
  ActivityMessageManager,
  ActivityMessageDetail,
  TopicFollow,
  ShortVideoManager,
  ShortVideoLook,
  ShortVideoDetail,
  ShortVideoRecord,
  ShortVideoScreenManager,
  ShortVideoScreenRecordManager,
  ShortVideoScreenToDeal,
  ShortVideoPersonRelationManager,
  ShortVideoMessageManager
}
